import * as types from '@/constants/mutationTypes'

const state = {
  clientsListProjects: [],
  clientCompanies: []
}
const getters = {
  clientsListProjects: state => state.clientsListProjects,
  clientCompanies: state => state.clientCompanies
}
const actions = {
  setClientsListProjects ({commit}, data) {
    commit(types.SET_CLIENTS_LIST_PROJECTS, {data})
  },
  setClientCompanies ({commit}, data) {
    commit(types.SET_CLIENT_COMPANIES, {data})
  }
}
const mutations = {
  [types.SET_CLIENTS_LIST_PROJECTS] (state, {data}) {
    state.clientsListProjects = data
  },
  [types.SET_CLIENT_COMPANIES] (state, {data}) {
    state.clientCompanies = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Clients/modules/store.js